import {StarIcon} from '@primer/octicons-react'

import {Label} from '@primer/react'

import type {BaseServer} from '../../../../types'

import styles from './GridCard.module.css'

type Props = {
  mcp: BaseServer
}

// Maps an extension type label to a Primer Label scheme so different types
// are visually distinguishable at a glance.
function schemeForType(extensionType: string): React.ComponentProps<typeof Label>['variant'] {
  switch (extensionType.toLowerCase()) {
    case 'mcp server':
      return 'accent'
    case 'agent':
      return 'success'
    case 'a2a agent':
      return 'sponsors'
    case 'skill':
      return 'attention'
    case 'canvas':
      return 'severe'
    default:
      return 'secondary'
  }
}

export function GridCard(props: Props) {
  const {mcp} = props

  const owner = mcp.name_with_owner ? mcp.name_with_owner.split('/')[0] : null

  return (
    <div className={styles.card}>
      <div className={styles.body}>
        <div className={styles.header}>
          <div className={styles.heading}>
            {mcp.owner_avatar_url ? (
              <div className={styles.logoContainer}>
                <img src={mcp.owner_avatar_url} alt={`${mcp.display_name} logo`} className={styles.logo} />
              </div>
            ) : null}

            <span className={styles.title}>{mcp.display_name}</span>
          </div>

          {mcp.extension_type ? (
            <div className={styles.typeLabel}>
              <Label variant={schemeForType(mcp.extension_type)}>{mcp.extension_type}</Label>
            </div>
          ) : null}
        </div>

        <p className={styles.description}>{mcp.description}</p>
      </div>

      <footer className={styles.footer}>
        {owner ? (
          <p className={styles.footerOwner}>
            By <span>{owner}</span>
          </p>
        ) : null}

        {mcp.stargazer_count ? (
          <div className={styles.footerStats}>
            <StarIcon size={14} />

            <span>{mcp.stargazer_count.toLocaleString()}</span>
          </div>
        ) : null}
      </footer>
    </div>
  )
}
